import React from 'react';
import '../DashboardSkeleton.css';

const line = (className = '') => <span className={`dashboard-skeleton referral-shimmer-line ${className}`} />;

export function ReferralSummarySkeleton() {
  return <div className="referral-shimmer" aria-label="Loading referral rewards">
    <div className="rsummary-card referral-shimmer-card">{line('short')}{line()}{line('short')}</div>
    <div className="invite-card referral-shimmer-card">{line('short')}{line()}{line()}</div>
  </div>;
}

export function ReferralPodiumSkeleton() {
  return <div className="rleaderboard referral-shimmer" aria-label="Loading top performers">
    {line('short')}
    <div className="referral-shimmer-podium">{[1, 2, 3].map((item) => <span key={item} className="dashboard-skeleton" />)}</div>
  </div>;
}

export function ReferralHistorySkeleton() {
  return <div className="history-list" aria-label="Loading referral history">
    {Array.from({ length: 8 }, (_, index) => <div className="history-card referral-shimmer-history" key={index}>
      <span className="dashboard-skeleton" />
      <div>{line('short')}{line()}</div>
      {line('short')}
    </div>)}
  </div>;
}

export function ReferralLeaderboardSkeleton() {
  return <div className="referral-rank-shimmer" aria-label="Loading referral leaderboard">
    <div className="top-three">
      {[2, 1, 3].map((place) => <div className={`top-player ${place === 1 ? 'first' : place === 2 ? 'second' : 'third'}`} key={place}>
        <span className="dashboard-skeleton referral-rank-shimmer__avatar" />
        {line('short')}
        {line('short')}
      </div>)}
    </div>
    <div className="rank-header"><span className="rank-heading">RANK LIST</span><span className="performer-heading">Top Performers</span></div>
    <div className="rank-list-wrapper"><div className="rank-list">
      {Array.from({ length: 6 }, (_, index) => <div className="rank-row" key={index}>
        <span className="dashboard-skeleton referral-rank-shimmer__number" />
        <span className="dashboard-skeleton referral-rank-shimmer__avatar small-badge" />
        {line()}{line('short')}
      </div>)}
    </div></div>
  </div>;
}
